
import ToolBarBottom from '../../components/ToolBarBottom'
import Scroller from 'vux/src/components/scroller/index.vue'
import Panel from 'vux/src/components/panel/index.vue'


export default {
name: 'BlankSailingList',
components: {
ToolBarBottom,
Scroller,
Panel
},
data () {
return {
platcode: '',
pageNo: 1,
pageSize: 10,
listData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
routeline: '',
pullupConfig: {
content: '',
downContent: '',
upContent: '',
loadingContent: ''
}
}
},
created: function () {
this.platcode = this.$UserUtils.getPlatCode()
this.routeline = this.$route.query.routeline
},
mounted: function () {
this.loadList()
},
methods: {
loadList: function () {
var that = this
var url = '/wxapi/blanksailing/getBlankSailingList?platcode=' + that.platcode + '&routeline=' + that.routeline
this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
that.listData = res.data
} else {
console.error(res.meta.message)
if (res.redirect) {
window.open(res.data)
} else {
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/blanksailing/BlankSailingList.vue